import { render, staticRenderFns } from "./HandlingIndex.vue?vue&type=template&id=69378142&"
import script from "./HandlingIndex.vue?vue&type=script&lang=js&"
export * from "./HandlingIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69378142')) {
      api.createRecord('69378142', component.options)
    } else {
      api.reload('69378142', component.options)
    }
    module.hot.accept("./HandlingIndex.vue?vue&type=template&id=69378142&", function () {
      api.rerender('69378142', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/portal-cebas/credentialing/handling/HandlingIndex.vue"
export default component.exports